const queryString = (params) => {
  if (typeof params !== 'object') {
    throw `queryStringBuilder only accepts an object parameter, reveived ${typeof params}`;
  }
  const items = [];
  Object.keys(params).forEach((key) => {
    if (typeof params[key] === 'object' && !Array.isArray(params[key])) {
      if (params[key] === null) {
        throw 'queryStringBuilder param cannot be null';
      } else {
        throw 'queryStringBuilder param object values must be arrays or primitives';
      }
    }
    if (Array.isArray(params[key])) {
      params[key].forEach((elem) => {
        if (elem && typeof elem === 'object') {
          throw 'queryStringBuilder array elements must be primitives';
        }
        items.push(`${key}=${elem}`);
      });
    } else if (params[key] !== undefined) {
      items.push(`${key}=${params[key]}`);
    }
  });
  if (items.length) {
    return `?${items.join('&')}`;
  } else {
    return '';
  }
};

export default queryString;
